import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EnterpriseMap } from '../../../model/Venture';
import HttpClient, { Callback, CallbackType, ExtraAction } from '../api';

const INITIAL_STATE: EnterpriseMap = {};

export const slice = createSlice({
  name: 'ventures-for-maps',
  initialState: INITIAL_STATE,
  reducers: {
    addVentureForMap: (state, action: PayloadAction<EnterpriseMap>) => {
      console.log('currentEnterprise', action.payload);
      const {
        batchs,
        id,
        name,
        neLatitude,
        neLongitude,
        publicity,
        rotate,
        swLatitude,
        swLongitude,
        file,
        zoom,
        publicityFiles,
      } = action.payload;

      return {
        ...state,
        id,
        name,
        image: file?.filename,
        ne: {
          latitude: neLatitude ? Number.parseFloat(neLatitude) : 0,
          longitude: neLongitude ? Number.parseFloat(neLongitude) : 0,
        },
        publicity,
        publicityFiles,
        rotate,
        sw: {
          latitude: swLatitude ? Number.parseFloat(swLatitude) : 0,
          longitude: swLongitude ? Number.parseFloat(swLongitude) : 0,
        },
        zoom: zoom ? zoom : 10,
        batchs,
      };
    },
  },
});

export const { addVentureForMap } = slice.actions;

export const findVentureForMapById = (
  ventureId: number,
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('findVentureForMapById by query success'),
      full: false,
    },
  ],
) => {
  return HttpClient.findVentureForMapById(
    ventureId,
    addVentureForMap.type,
    customErrorsMap,
    extraActions,
    callbacks,
  );
};

export default slice.reducer;
